"use strict";
(self["webpackChunkbranch_basics"] = self["webpackChunkbranch_basics"] || []).push([[3817],{

/***/ 3817:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ GlobalHeader)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function GlobalHeader({ wrapper }) {
  const settings = {

    // GLOBALLY-SHARED
    announcementBar: '[data-announcement-bar]',


    stickyNav: wrapper,

    primaryNavigationBars: '[data-primary-nav]',
    desktopNavBar: '[data-primary-nav="desktop"]',
    mobileNavBar: '[data-primary-nav="mobile"]',

    animateClass: "animate", 

    openCart: '[data-hook="open-cart"]',
    cartCount: '[data-hook="cart-count"]',

    
    // LEGACY-SPECIFIC


    // REFRESH-SPECIFIC






    // MEGA MENU

    megaMenu: "[data-hook='mega-menu']", // Outer wrapper
    megaContainer: "[data-hook='mega-container']", // Inner content wrapper
    subMenuBack: "[data-hook='close-submenu']", // submenu close button

    clickTriggerLinks: "[data-hook='mega-click-link']", // Shop, Learn
    hoverTriggerLinks: "[data-hook='mega-hover-link']", // Shop, Learn

    hoverableImageLinks: "[data-hook='mega-hover-image-link']", // Links inside mega menu
    hoverableImages: "[data-hook='mega-hover-image']", // Hoverable-images inside mega menu

  };


  const $cache = {
    $wrapper: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper),
    $announcementBar: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.announcementBar),
    $navBars: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.primaryNavigationBars),
    $cartTriggers: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.openCart),

    $activeHeader: null,
    $desktopNavBar: null,
    $mobileNavBar: null,
    $activeNavBar: null,


    // MEGA MENU
    $megaMenus: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.megaMenu),
    $megaMenuContainers: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.megaContainer),
    $megaMenuClickTriggerLinks: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.clickTriggerLinks),
    $megaMenuHoverTriggerLinks: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.hoverTriggerLinks),
    $subMenuBackstepButtons: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.subMenuBack),
    $hoverableMegaMenuImageLinks: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.hoverableImageLinks),
    $hoverableMegaMenuImages: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(settings.hoverableImages),

    $activeMegaMenuTrigger: null,
    $activeMegaMenu: null,
    $activeMegaMenuPanel: null,

  };


  const config = {
    announcementBarShouldDisplayOnLoad: $cache.$announcementBar.data("showAnnouncementBar") ? true : false,
    announcementBarHeight: 0,

    navBarHeight: 60,

    lastScrollPos: window.scrollY,
    mobileScreenThreshold: 768, // ie, Tailwind md: threshold for mobile sizes
    
    hoverLinkTimeoutId: null, // global timeout ref, used to reset hover-out events
    hoverLinkTimeoutBuffer: 600, // time in milliseconds
    
    onClass: 'tw-on', 
  }
  
  
  ;(function init() {
    refreshConfig();

    initAnnouncementBar();
    initNavBars();

    initializeEventListeners();
  })()


  function initializeEventListeners() {
    // * ANNOUNCEMENT BAR (Only install scroll-listener if an announcement exists)
    if (config.announcementBarHeight > 0) {
      const responsibleStickyAnnouncementBarHandler = throttleTunnel(handleStickyAnnouncementBar, 15); // Throttled version of handleStickyAnnouncementBar
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('scroll', responsibleStickyAnnouncementBarHandler);
    }
    

    // * NAVIGATION BAR
    $cache.$cartTriggers.on('click', () => jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('cart:open'))
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('load resize orientationchange', refreshConfig);


    // * MEGA MENU
    $cache.$megaMenuClickTriggerLinks.on('click', openMegaMenuViaClick);

    $cache.$megaMenuHoverTriggerLinks.on('click', openMegaMenuViaClick);
    $cache.$megaMenuHoverTriggerLinks.on('mouseenter focusin', openMegaMenuViaHover);

    $cache.$subMenuBackstepButtons.on('click', closeSubMenu);
    $cache.$hoverableMegaMenuImageLinks.on('mouseenter mouseleave focusin focusout', handleHoverableImageSwap);
    $cache.$hoverableMegaMenuImageLinks.on('click', 'a', closeMegaMenu); 
  }


  function initAnnouncementBar() {
    if (!config.announcementBarShouldDisplayOnLoad) return; // Customize-Theme controlled hide/show toggle
    
    $cache.$announcementBar.addClass(config.onClass); // enable announcement bar
    config.announcementBarHeight = getElementHeight($cache.$announcementBar);
  }


  function initNavBars() {
    if (!$cache.$navBars || $cache.$navBars.length === 0) return;

    // Set initial top-offset for Desktop + Mobile Navs
    $cache.$navBars.each((index, navBar) => {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(navBar).css({ position: window.scrollY <= config.announcementBarHeight ? 'absolute' : '' });

      if ( window.scrollY <= config.announcementBarHeight ) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(navBar).css({ top: config.announcementBarHeight });
      } else {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(navBar).css({ top: 0 });
      }
    })
  }


  function isMobileScreen() {
    if (window.innerWidth > config.mobileScreenThreshold) {
      return false;
    } else {
      return true;
    }
  }


  function setActiveNavBar() {
    $cache.$desktopNavBar = $cache.$navBars.filter(settings.desktopNavBar);
    $cache.$mobileNavBar = $cache.$navBars.filter(settings.mobileNavBar);

    if (!!isMobileScreen()) {
      $cache.$activeNavBar = $cache.$mobileNavBar;
    } else {
      $cache.$activeNavBar = $cache.$desktopNavBar;
    }

    config.navBarHeight = getElementHeight($cache.$activeNavBar);
  }


  function refreshConfig() {
    // Check for cookie-based discount code 
    handleCookieBasedDiscounts();
    
    // Update activeNavBar (in case we've swapped between Desktop/Mobile)
    setActiveNavBar();
  
    // Update NavBar + AnnouncementBar CSS Vars
    setCssVars();
  }


  function setCssVars() {
    // TODO: store in sessionStorage to improve persistence across pages..

    document.documentElement.style.setProperty('--navbar-height', `${config.navBarHeight}px`)
    document.documentElement.style.setProperty('--announcement-bar-height', `${config.announcementBarHeight}px`)

    sessionStorage.setItem('css-var--global-navbar-height', config.navBarHeight);
  }


  function handleCookieBasedDiscounts() {
    // identify any discounts (coming from URL Params past/current)
    // if discount is present, append html to our announcement bar + show the announcement bar
    let cookies = getCookies();

    if (cookies && cookies["discount_code"] !== undefined) {
      let announcementItemHTML = `<p class="tw-text-[0.6125rem] md:tw-text-[0.8125rem] [&_a]:tw-underline tw-m-0 tw-text-white">Code <span class="tw-font-bold">${cookies["discount_code"]}</span> has been applied. Your discount will be displayed at checkout.</p>`

      $cache.$announcementBar.html(announcementItemHTML)
      config.announcementBarHeight = getElementHeight($cache.$announcementBar);
      $cache.$announcementBar.addClass(config.onClass);
    }
  }


  function getCookies() {
    // Access the cookies using document.cookie.
    // Use the .split() method to split them on ; to get an array of cookies.
    // Use the map() method to create an array of key-value pairs for each cookie.
    // Transform the array of key-value pairs into an object using Object.fromEntries().
    let currentCookies = document.cookie;
    let parsedCookies = Object.fromEntries(
      currentCookies.split(';').map(cookie => {
            const [name, val] = cookie.split('=').map(c => c.trim());
            return [name, val];
        })
    );
    return parsedCookies;
  }


  function getElementHeight($element) {
    const elementIsVisible = $element.css('display') != 'none'

    return elementIsVisible
      ? $element.outerHeight() // note: outerHeight is inclusive of element-padding
      : 0;
  }


  function throttleTunnel(functionToThrottle, limit=250) {
    // Ensures functionToThrottle only fires once every 'limit' (measured in milliseconds)
    let inThrottle = false;
    let lastFunc;
    let lastRan;

    return function(...args) {
      if (!inThrottle) {
        functionToThrottle.apply(this, args);
        lastRan = Date.now();
        inThrottle = true;
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(() => {
          if (Date.now() - lastRan >= limit) {
            functionToThrottle.apply(this, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }
  

  function handleStickyAnnouncementBar() {
    config.announcementBarHeight = getElementHeight($cache.$announcementBar)

    // Set navBar position
    $cache.$activeNavBar.css({ position: config.announcementBarHeight ? 'absolute' : '' })

    // Handle NavBar + AnnouncementBar tandem
    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop() > 1) {
      let topOrZero = config.announcementBarHeight - jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop() <= 0 ? 0 : config.announcementBarHeight - jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop();
      $cache.$activeNavBar.css({ top: topOrZero });

        if ( window.innerWidth < 767 ) {
            let topOrHidden = jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop() - config.announcementBarHeight <= 0 ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop() : config.announcementBarHeight;
            $cache.$announcementBar.css({ top: -topOrHidden });
        }

      if ( jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop() > 47 ) {
        $cache.$activeNavBar.addClass('is-stuck');
      }

    } else {
      $cache.$activeNavBar.css({ top: config.announcementBarHeight });
      if (!hasOpenMenus()) {
        $cache.$activeNavBar.removeClass('is-stuck');
      }
      if( window.innerWidth < 767 ) {
        $cache.$announcementBar.css({ top: 0 });
      }
    }
  }






   // ! MEGA MENUs
  function hasOpenMenus() {
    return $cache.$megaMenus.hasClass(config.onClass);
  }

  function setActiveMegaMenuRef(menuReference) {
    $cache.$activeMegaMenu = jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.megaMenu + '[data-linked-menu="' + menuReference + '"]');
    $cache.$activeMegaMenuPanel = $cache.$activeMegaMenu.find(settings.megaContainer + '[data-linked-menu="' + menuReference + '"]');
  }


  // Hover/Focus on Shop -> open mega menu for Shop
  function openMegaMenuViaHover(e) {
    let $hoverTrigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
    let menuReference = $hoverTrigger.data('linked-menu');
    setActiveMegaMenuRef(menuReference); // update state
    
    createTemporaryHoverListeners(e) // set listeners on the menu that's about to open
    refreshMegaMenuPersistence() // clear any active timeouts
    openMegaMenu(menuReference); // open menu
  }
  

  // Click on Shop -> open mega menu for Shop
  function openMegaMenuViaClick(e) {
    let $clickTrigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
    let menuReference = $clickTrigger.data('linked-menu');
    setActiveMegaMenuRef(menuReference); // update state

    openMegaMenu(menuReference);
  }


  function createTemporaryHoverListeners(e) {
    // 1.) When mouse or keyboard user leaves mega menu, close mega menu
    $cache.$activeMegaMenuPanel.on('mouseleave', (e) => closeMegaMenuViaHover(e, 'mouse'))
    $cache.$activeMegaMenuPanel.on('focusout', (e) => closeMegaMenuViaHover(e, 'keyboard'))

    // 2.) Prevent accidentally closing the mega menu if mouse leaves the mega menu, but for LESS than our hoverLinkTimeoutBuffer
    $cache.$activeMegaMenuPanel.on('mouseenter', refreshMegaMenuPersistence)

    // TODO: 3.) If 'Escape' is pressed while menu is open, close menu

  }

  function closeMegaMenuViaHover(e, interactionType) {
    refreshMegaMenuPersistence(); // remove any pending timeouts

    // * START timeout-debounce loop:
    // * (Timeout is cancelled if user moves mouse / focus BACK into the hoverable mega menu before timeout expires)
    switch (interactionType) {
      case 'mouse':
        config.hoverLinkTimeoutId = setTimeout(() => {
          closeMegaMenu()
          garbageCollectTemporaryHoverListeners()
        }, config.hoverLinkTimeoutBuffer)
        break;

      case 'keyboard':
        let itemIsWithinActiveMegaMenu = $cache.$activeMegaMenuPanel.has(e.relatedTarget).length > 0 ? true : false;
        if (!itemIsWithinActiveMegaMenu) {
          config.hoverLinkTimeoutId = setTimeout(() => {
            closeMegaMenu()
            garbageCollectTemporaryHoverListeners()
          }, config.hoverLinkTimeoutBuffer)
        }
        break;
    
    }
  }

  function garbageCollectTemporaryHoverListeners() {
    // Since eventlisteners are set on $activeMegaMenuPanel every time a menu is opened, garbageCollect to prevent memoryLeaks
    $cache.$activeMegaMenuPanel.off('mouseleave', (e) => closeMegaMenuViaHover(e, 'mouse'))
    $cache.$activeMegaMenuPanel.off('focusout', (e) => closeMegaMenuViaHover(e, 'keyboard'))
    $cache.$activeMegaMenuPanel.off('mouseenter', refreshMegaMenuPersistence)
    // TODO: If 'Escape' is pressed while menu is open, close menu
  }

  function refreshMegaMenuPersistence() {
    // * CLOSE timeout-debounce loop:
    // * (Timeout is cancelled if user moves mouse / focus BACK into the hoverable mega menu before timeout expires)
    clearTimeout(config.hoverLinkTimeoutId)
  }


  


  // Click on Shop -> open mega menu for Shop
  function openMegaMenu(menuReference) {

    let hasOpenMenu = hasOpenMenus(); // check for any currently-open menus
    let isSubmenuLink = menuReference?.includes('submenu'); // set boolean identifier for submenus
    
    // Update trigger aria attributes
    const menuID = $cache.$activeMegaMenu.attr('id');
    $cache.$activeMegaMenuTrigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[aria-controls="${ menuID }"]`);


    // Handle expandedAttr
    let expandedAttr = null;
    if ( $cache.$activeMegaMenuTrigger.attr('aria-expanded') ) 
      expandedAttr = JSON.parse($cache.$activeMegaMenuTrigger.attr('aria-expanded'));


    if ( !isSubmenuLink ) {
      // NOT a submenu -> close any other top-level menus when opening this one
      $cache.$megaMenuClickTriggerLinks.not($cache.$activeMegaMenuTrigger).removeClass(config.onClass);
      $cache.$megaMenuHoverTriggerLinks.not($cache.$activeMegaMenuTrigger).removeClass(config.onClass);

      // if current top-level menu is expanded, close it
      if ( expandedAttr ) {
        $cache.$megaMenuClickTriggerLinks.not($cache.$activeMegaMenuTrigger).attr('aria-expanded', false);
        $cache.$megaMenuHoverTriggerLinks.not($cache.$activeMegaMenuTrigger).attr('aria-expanded', false);
      }
    }

    // Handle $activeMegaMenuTrigger state(s)
    $cache.$activeMegaMenuTrigger.toggleClass(config.onClass);
    if ( expandedAttr ) $cache.$activeMegaMenuTrigger.attr('aria-expanded', !expandedAttr);

    // Close $activeMegaMenuTrigger if it is already open
    if ( $cache.$activeMegaMenu.hasClass(config.onClass) ) {
      return closeMegaMenu();
    }

    // Mobile-only: 
    if ( !isMobileScreen() && hasOpenMenu ) {
      $cache.$megaMenus.removeClass(config.onClass);
      $cache.$megaMenuContainers.removeClass(config.onClass);

      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyNav).addClass('is-stuck');

      $cache.$activeMegaMenu.addClass(config.onClass);
      setTimeout(function() {
        $cache.$activeMegaMenuPanel.addClass(config.onClass);
      }, 100);

      addNoScroll();

      return;
    }


    // todo: add check for if the openMenu (if any) is the menu that we're currently trying to open (ie, prevent open/close of the same menu behavior)
    if ( hasOpenMenu && !isSubmenuLink ) {
      closeMegaMenu();
    } else {
      if (hasOpenMenu) {
        if (isMobileScreen()) { // open just the sub-menu
          $cache.$activeMegaMenu.addClass(config.onClass);
          setTimeout(function() {
            $cache.$activeMegaMenuPanel.addClass(config.onClass);
          }, 100);


        } else { // open the mega menu (without animations) and close any other open menus
          $cache.$megaMenus.not($cache.$activeMegaMenu).removeClass(config.onClass);
          $cache.$megaMenuContainers.not($cache.$activeMegaMenuPanel).removeClass(config.onClass);

          $cache.$activeMegaMenu.addClass(config.onClass);
          $cache.$activeMegaMenuPanel.addClass(config.onClass);
          switchImageToMain();
        }

      } else { // no menus are open -> open & animate the active menu.
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyNav).addClass('is-stuck');

        $cache.$activeMegaMenu.addClass(config.onClass);

        setTimeout(function(){
          $cache.$activeMegaMenuPanel.addClass(config.onClass);
        }, 100);

        addNoScroll();
      }
    }

  }



  function addNoScroll() {
    config.lastScrollPos = window.scrollY;
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).attr('data-scroll-lock', true)
  }


  function removeNoScroll() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document.body).attr('data-scroll-lock', false)
    window.scrollTo(0, config.lastScrollPos);
  }


  function closeMegaMenu(e){
    $cache.$megaMenuClickTriggerLinks.removeClass(config.onClass).attr('aria-expanded', false);
    $cache.$megaMenuHoverTriggerLinks.removeClass(config.onClass).attr('aria-expanded', false);
    
    if ( e ) {}

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).scrollTop() === 0) {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(settings.stickyNav).removeClass('is-stuck');
    }

    $cache.$megaMenuContainers.removeClass(config.onClass);

    setTimeout(function(){
      $cache.$megaMenus.removeClass(config.onClass);
    }, 400);

    removeNoScroll();
  }



  function closeSubMenu(e){
    e.preventDefault();
    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this);
    let linkedMenuReference = $this.data('linked-menu');


    // Update trigger aria attributes
    $cache.$megaMenuContainers.each((_, container) => {
      const menuID = jquery__WEBPACK_IMPORTED_MODULE_0___default()(container).closest(settings.megaMenu).attr('id');
      $cache.$activeMegaMenuTrigger = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[aria-controls="${ menuID }"]`);
      $cache.$activeMegaMenuTrigger.attr('aria-expanded', false);
    });

    setActiveMegaMenuRef(linkedMenuReference);
    $cache.$activeMegaMenuPanel.removeClass(config.onClass);

    setTimeout(function(){
      $cache.$activeMegaMenu.removeClass(config.onClass);
    }, 400);
  }



  function handleHoverableImageSwap(e) {
    let $targetLink = jquery__WEBPACK_IMPORTED_MODULE_0___default()(e.currentTarget); 
    
    let $linkedImage = $cache.$hoverableMegaMenuImages.filter(`[data-linked-image="${ $targetLink.data('linked-image') }"]`);
    let $associatedDefaultImage = $cache.$hoverableMegaMenuImages.filter(`[data-linked-image="${ $linkedImage.data('default-linked-image') }"]`); 
    
    let eventType = e.type;
    let targetIsActive = false;

    // IF a link is interacted-with (mouseenter/focus), set its image active
    if (eventType === 'mouseenter' || eventType === 'focusin') {
      targetIsActive = true;

    // ELSE a link is no longer being interacted-with (mouseleave/blur), revert to original/default image
    } else if (eventType === 'mouseleave' || eventType === 'focusout') {
      targetIsActive = false;
    }

    $linkedImage.toggleClass(config.onClass, targetIsActive).attr("role", resolveRoleAttr(targetIsActive));
    $associatedDefaultImage.toggleClass(config.onClass, !targetIsActive).attr("role", resolveRoleAttr(!targetIsActive));
  }


  function resolveRoleAttr(bool) {
    if (!!bool) {
      return "alert";
    } else {
      return null;
    }
  }


}


/***/ })

}]);